import { Config } from "@config";
import { http } from "bm-ui-kit";
import type { FormFields, LoanInsuranceRequest, LoanInsuranceResponse } from "./types";

export function calculate(values: FormFields): Promise<LoanInsuranceResponse> {
	const request: LoanInsuranceRequest = {
		...values,
		afraidOfLosingJob: values.fears.includes("afraidOfLosingJob"),
		afraidOfDecliningHealth: values.fears.includes("afraidOfDecliningHealth"),
		afraidOfUnexpectedDeath: values.fears.includes("afraidOfUnexpectedDeath"),
	};

	return http.post(Config.getApiUrl("/api/public/loan-insurance/calculate"), request);
}
